import BreadcrumbPurchase from "./purchaseComponents/BreadcrumbPurchase";
import ThumbsUpOlin from "../../../assets/images/thumbs-up.png";
import { useNavigate } from "react-router-dom";

const OlinAmanahConfirm = () => {
  const navigate = useNavigate();

  return (
    <div className="text-[12px] text-[#2C3E5D]">
      <div className="mt-[70px] lg:mt-0">
        <BreadcrumbPurchase />
        <p className="text-[24px] font-semibold mb-12">Aktivasi Olin Amanah</p>

        <div className="flex flex-col items-center justify-center">
          <div>
            <img src={ThumbsUpOlin} className="w-[150px] mb-8" />
          </div>
          <div className="flex flex-col items-center justify-center text-center">
            <p className="text-[20px] font-semibold mb-2">
              Aplikasi Anda Sedang Direview
            </p>
            <p className="text-[16px] mb-2">
              Aplikasi anda berhasil dikirim dan sedang direview oleh tim kami,
              <br />
              hasil akan kami info melalui email.
            </p>
            <button
              type="button"
              className={`flex items-center justify-center gap-2 text-white bg-[#94C679] hover:bg-gray-300 rounded-md w-fit py-2.5 px-4 text-[14px] disabled:bg-gray-300 `}
              onClick={() => navigate(`/purchase/checkout`)}
            >
              Lanjutkan Pembayaran
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OlinAmanahConfirm;
